import { Ref1DTO } from "./dto/ref1.dto";
import { PontoDeSaida } from "./productvenda";

export class Produto {
    id = 0;
    nome = '';
    anotacao = '';
    horarioSaida = '';
    pontoSaida = '';
    valor = 0.00;
    capacidade = 0;
    periodicidade = '';
    status = '';
    obs = '';
    fornecedor: Ref1DTO = {id: 1, nome: ''};
    cidade: Ref1DTO = {id: 1, nome: ''};
    pontoDeSaida: Ref1DTO[] = [{id: 1, nome: ''}];
    cupom: Ref1DTO = {id: 1, nome: ''};
}

export class ProdutoConsulta {
    id = 0;
    nome = '';
    anotacao = '';
    horarioSaida = '';
    pontoSaida = '';
    pontosDeSaida: PontoDeSaida[];
    valor = 0.00;
    capacidade = 0;
    periodicidade = '';
    status = '';
    obs = '';
    fornecedor: Ref1DTO = {id: 1, nome: ''};
    cidade: Ref1DTO = {id: 1, nome: ''};
    pontoDeSaida: Ref1DTO[] = [{id: 1, nome: ''}];
    cupom: Ref1DTO = {id: 1, nome: ''};
}
